import ProgressBar from "../../ui/ProgressBar";

export default function ProgressSection({ complete }: { complete: Record<string, boolean> }) {
  return (
    <section className="sticky top-0 z-50 bg-white border-b border-black pb-6">
      <ProgressBar complete={complete} />
    </section>
  )
}